import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { Ge as h, hi as p, w as c, bo as a, M as d } from "./abstract-base-8edf0a84-e11d45a3.js";
import { S as u } from "./chart-base.helpers-722f3948-fa82acec.js";
import { s as m } from "./data-item-base-9dcf69f4-535cbd7c.js";
import "./unsafe-svg-8b07bc77-f986d223.js";
import "./legend-5216905c-c7014324.js";
import "./legend-circle-0e9cbc84-7a23b644.js";
import "./directive-daf4e9b6-abc0af54.js";
var b = {
    beaconTagName: "beacon-chart-tooltip-data"
  },
  g = h(_templateObject || (_templateObject = _taggedTemplateLiteral([".container{align-items:baseline;display:flex}.container.main{border-block-end:var(--beacon-chart-tooltip-override-divider-border-block-end, none);padding-block-end:var(--beacon-chart-tooltip-override-container-main-padding-block-end, 0)}.container.subset{margin-block-start:var(--beacon-chart-tooltip-override-container-subset-margin-block-start, 0)}.icon{align-items:center;display:grid;justify-content:start;margin-inline-end:var(--beacon-unit-subatomic);min-inline-size:var(--beacon-unit-base)}.icon ::slotted(svg),.icon .fallback-icon{fill:var(--icon-color, currentColor)}.label,.metric{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}.label{padding-block-start:var(--beacon-chart-tooltip-override-label-padding-block-start, 0)}.metric{font-weight:var(--beacon-font-weight-bold);margin-inline-start:var(--beacon-unit-atomic);padding-block-start:var(--beacon-chart-tooltip-override-metric-padding-block-start, 0)}:host([subset]) .icon{padding-inline-start:3px}:host([subset]) .icon ::slotted(svg),:host([subset]) .icon .fallback-icon{inline-size:var(--beacon-unit-subatomic)}\n"])));
var f = Object.defineProperty,
  y = Object.getOwnPropertyDescriptor,
  v = function v(r, e, i, o) {
    for (var t = o > 1 ? void 0 : o ? y(e, i) : e, n = r.length - 1, s; n >= 0; n--) (s = r[n]) && (t = (o ? s(e, i, t) : s(t)) || t);
    return o && t && f(e, i, t), t;
  };
var l = /*#__PURE__*/function (_p) {
  _inherits(l, _p);
  function l() {
    var _this;
    _classCallCheck(this, l);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments)), _this.beaconTagName = b.beaconTagName, _this.disableIcon = !1, _this.subset = !1;
    return _this;
  }
  _createClass(l, [{
    key: "renderIcon",
    /** Conditionally render icon HTML. */value: function renderIcon() {
      return this.disableIcon ? c : a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<div class=\"icon\">\n          <slot name=\"icon\">", "</slot>\n        </div>"])), u(this.index % 5));
    } /** Conditionally render label HTML. */
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      return this.label ? a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div class=\"label\">", "</div>"])), this.label) : c;
    } /** Conditionally render value HTML. */
  }, {
    key: "renderValue",
    value: function renderValue() {
      return this.value ? a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<div class=\"metric\">", "</div>"])), this.value) : c;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(l.prototype), "connectedCallback", _this2).call(_this2), _this2.requiredProps = ["label", "value"];
      });
    }
  }, {
    key: "render",
    value: function render() {
      return a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<style>\n        ::slotted(svg),\n        .fallback-icon {\n          --icon-color: ", ";\n        }\n      </style>\n\n      <div class=\"container ", "\">", " ", " ", "</div>"])), this.iconColor, this.dataLevel, this.renderIcon(), this.renderLabel(), this.renderValue());
    }
  }, {
    key: "dataLevel",
    /** The hierarchy level of the data item. */get: function get() {
      return this.subset ? "subset" : "main";
    } /** The appropriate color for the icon depending on hierarchy. */
  }, {
    key: "iconColor",
    get: function get() {
      return this.subset ? "var(--beacon-chart-tooltip-divider-color-background)" : this.color ? this.color : "var(--beacon-chart-override-drilldown-series-color-".concat(this.index, ", var(--beacon-chart-series-color-").concat(this.index, "))");
    }
  }], [{
    key: "styles",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(l), "styles", this)), [g]);
    }
  }]);
  return l;
}(p(m));
l.tagName = b.beaconTagName;
v([d({
  attribute: "disable-icon",
  type: Boolean
})], l.prototype, "disableIcon", 2);
v([d({
  type: Boolean
})], l.prototype, "subset", 2);
export { l as BeaconChartTooltipData };